import React from 'react'

const QR = () => {

const currentPath = window.location.pathname;

if (currentPath.includes('/QR/')) {
  // Remove '/QR/' from the path
  const newPath = currentPath.replace('/QR/', '/');

  window.location.href = "https://quickchart.io/chart?cht=qr&chs=300x300&chl="+ window.location.origin + newPath;
}

    
  return (
    <div>QR</div>
  )
}

export default QR